import { applyEmptyChartState, seriesHasData } from '@/data/chartEmptyState.js'

export function getChartOptions(dataArray) {
  const dataSeries = {
    name: '',
    type: 'line',
    smooth: true,
    showSymbol: false,
    areaStyle: {
      opacity: 0.1,
    },
    lineStyle: {
      width: 1,
    },
    data: [],
  }

  const options = {
    title: {
      text: '',
    },
    // graphic: getAnimationConfig(),
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },
    },
    legend: {
      orient: 'horizontal',
      bottom: '4%',
    },
    grid: {
      top: '3%',
      left: '3%',
      right: '4%',
      bottom: '15%',
      containLabel: true,
    },
    xAxis: {
      type: 'time',
      boundaryGap: false,
    },
    yAxis: {
      type: 'value',
      min: 0,
    },
    series: [],
  }

  var maxValue = 0

  options.series = []
  if (dataArray != undefined && Object.keys(dataArray).length > 0) {
    const keys = Object.keys(dataArray)
    for (var i = 0; i < keys.length; i++) {
      const key = keys[i]
      const arr1 = Object.assign({}, dataSeries)
      arr1.id = key
      arr1.name = key.toUpperCase()
      const itemArray = dataArray[key]
      for (var j = 0; j < itemArray.length; j++) {
        const val1 = itemArray[j][1]
        if (val1 > maxValue) maxValue = val1
      }
      // console.log(itemArray)
      arr1.data = itemArray
      options.series.push(arr1)
    }
  }

  var devider = 1
  var label = 'p/s'

  if (maxValue > 1000000000) {
    devider = 1000000000
    label = 'Gp/s'
  } else if (maxValue > 1000000) {
    devider = 1000000
    label = 'Mp/s'
  } else if (maxValue > 1000) {
    devider = 1000
    label = 'Kp/s'
  }

  if (devider > 1) {
    for (var k = 0; k < options.series.length; k++) {
      const item = options.series[k]
      for (var m = 0; m < item.data.length; m++) {
        item.data[m][1] = item.data[m][1] / devider
      }
    }
  }

  options.yAxis.axisLabel = {
    formatter: function (value) {
      return value + ' ' + label
    },
  }

  return applyEmptyChartState(options, seriesHasData(options.series))
}
